
const initialState={
    exam:{allotted_time:5400,window_restricted:0},
    data:{
        'users':[],
        'tasks':[],
        'task_logs':[],
        'roles':[]
    },
    logged_in:false,
    user:{},
    togClass:'',
}

const rootReducer= (state=initialState,action) => {
 switch(action.type){
    case 'SET_EXAM': 
        return {...state,exam:action.payload}
    case 'SIDE_TOGGLE':
        console.log(action.payload)
        return {...state,togClass:action.payload!=true?'open':''}
    case 'SET_DATA':
        console.log(action.payload)
        return {...state, data:action.payload};
    case 'SET_LOGIN':
        return {...state, logged_in:true};
    case 'SET_LOGOUT':
        return {...state, logged_in:false};
    case 'SET_USER':
        return {...state , user:action.payload}
    default:
        return state
 }
}

export default rootReducer